<template>
	<div class="PaymentMethodPixMobile w-100">
		<div class="row">
			<div class="col bx-resumo col-lg-8 offset-lg-2 px-lg-5">
				<ul class="resumo-pedido">
					<li class="px-3 my-1">
						<label class="field">Nº do Pedido:</label>
						<label>
							<b>{{boleto.order}}</b>
						</label>
					</li>
					<li class="px-3 my-1">
						<label class="field">Vencimento:</label>
						<label>
							<b>{{$helper.formatDateMMDDYYYY(pix.expiration_date)}}</b>
						</label>
					</li>
					<li class="px-3 my-1">
						<label class="field">Valor:</label>
						<label>
							<b>R$ {{$helper.formatValue(boleto.valor)}}</b>
						</label>
					</li>
				</ul>
			</div>
		</div>
		<div class="row mb-4" v-if="pix.pix_img">
			<div class="col bx-resumo col-lg-8 offset-lg-2 px-lg-5">
				<ul class="resumo-pedido">
					<li class="px-3 pt-2 pb-2 text-center">
						<b>Escaneie o QR Code</b> e pague com Pix.
					</li>
					<li class="px-3 py-2 text-center">
						<img :src="pix.pix_img">
					</li>
					<li class="px-3 pt-2 pb-3 text-center pointer" style="height:60px;">
						<span class="box_copy_paste" @click="copyToClipboard(pix.pix_code)">
							<img :src="require('@/assets/img/pix_copy_and_paste.svg')"> &nbsp; PIX COPIA E COLA
						</span>
						<div id="tooltip_copy_paste" class="tooltip hide_tooltip">
							<div class="arrow"></div>
							<div class="tooltip-inner">Copiado!</div>
						</div>
					</li>
				</ul>
			</div>
		</div>

	</div>

</template>

<script>

export default {
	name: 'PaymentMethodPix',
	data(){
		return{
			payload: {},
			pix_img: '',
			pix_code: '',
			payment_id: '',
		}
	},

	components: {},

	mounted: function(){},

	computed: {
		boleto(){
			return this.$store.state.boleto.boleto;
		},

		pix(){
			return this.$store.state.boleto.pix;
		},
	},

	methods: {
		copyToClipboard: function(val){
			this.$helper.copyToClipboard(val);

			document.querySelector("#tooltip_copy_paste").classList.add('show_tooltip');
			document.querySelector("#tooltip_copy_paste").classList.remove('hide_tooltip');

			window.setTimeout(() => {
				document.querySelector("#tooltip_copy_paste").classList.remove('show_tooltip');
				document.querySelector("#tooltip_copy_paste").classList.add('hide_tooltip');
			}, 1000);
		}
	},

	filters: {
		taxid_display: function(value){
			let taxid = value;
			let returnValue = '';
			
			if(taxid.length > 11){
				returnValue = taxid.replace(/(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/g,"\$1.\$2.\$3\/\$4\-\$5");
			}else{
				returnValue = taxid.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/g,"\$1.\$2.\$3\-\$4");
			}
			
			return returnValue;

		},
	},
}
</script>